// src/MSMEMetaverseLanding.jsx
import React, { useState } from "react";
import MSMEMetaverseHeroSection from "./components/MSMEMetaverseHeroSection";
import MSMEMetaverseStakeholdersGrid from "./components/MSMEMetaverseStakeholdersGrid";
import MSMEMetaverseMarketplace from "./components/MSMEMetaverseMarketplace";
import MSMEMetaverseStagedTimeline from "./components/MSMEMetaverseStagedTimeline";
import MSMEMetaverseAnimatedUniverse from "./components/MSMEMetaverseAnimatedUniverse";
import MSMEMetaverseMap from "./components/MSMEMetaverseMap";

const MSMELinkMetaverseLanding = () => {
  // Dummy "player"
  const [player] = useState({ id: "player1", name: "You" });

  // Dummy marketplace dataset (you’ll replace with real listings later)
  const [selectedListings, setSelectedListings] = useState([
    { id: 1, type: "crop", name: "Tomato", owner: "player1" },
    { id: 2, type: "crop", name: "Potato", owner: "resident1" },
    { id: 3, type: "item", name: "Tractor", owner: "resident2" },
    { id: 4, type: "crop", name: "Wheat", owner: null },
    { id: 5, type: "facility", name: "Warehouse", owner: "resident3" },
  ]);

  // Example handlers
  const handleContact = (listing) => {
    alert(`Contacting owner of ${listing.name}`);
  };

  const handleMakeOffer = (listing, amount) => {
    alert(`Making offer of ₹${amount} for ${listing.name}`);
  };

  return (
    <div className="min-h-screen bg-black px-4 py-6">
      <MSMEMetaverseHeroSection />
      <MSMEMetaverseAnimatedUniverse />

      {/* Marketplace */}
      <MSMEMetaverseMarketplace onSelect={setSelectedListings} />

      {/* Village / Market Map */}
      <MSMEMetaverseMap
        rows={6}
        cols={8}
        dataset={selectedListings}
        ownerId={player.id}
        onContact={handleContact}
        onMakeOffer={handleMakeOffer}
      />

      <MSMEMetaverseStagedTimeline />

      {/* CTA */}
      <div className="text-center mt-12">
        <button className="bg-green-700 text-white px-6 py-3 rounded-2xl text-lg font-semibold shadow-lg hover:bg-green-800 transition">
          Join Now
        </button>
      </div>
    </div>
  );
};

export default MSMELinkMetaverseLanding;
